import { Button, Tag } from '@loadsmart/miranda-react'

import {
  formatDate,
  formatDescriptionWithZip,
  formatFacilityName,
} from 'core/presenters/stopPresenter'
import { Icon } from 'core/ui/components/icon/Icon'
import { StopsTimeline } from 'core/ui/components/stop/StopsTimeline'

import { formatBidButtonLabel } from '../presenter/spotQuotePresenter'
import { SpotQuoteBidDeadline } from './SpotQuoteBidDeadline'
import { type SpotQuoteCardProps } from './SpotQuoteCard'
import { BodyWrapper, CardWrapper, DeadlineWrapper } from './SpotQuoteCard.styles'

export function SingleSpotQuoteMobileCard({
  expiredQuote,
  item,
  showDeadline,
  onBidClick,
}: SpotQuoteCardProps) {
  const { lanes, isUnderNegotiation } = item
  // for single spot quotes, the rates array will always contain a single SpotQuoteListRate
  const [{ quote }] = lanes.rates

  return (
    <CardWrapper>
      {showDeadline && (
        <DeadlineWrapper>
          <SpotQuoteBidDeadline
            deadline={quote.bidsDeadline}
            isExpired={expiredQuote}
            isMultiline
          />
        </DeadlineWrapper>
      )}
      <BodyWrapper>
        {isUnderNegotiation && (
          <Tag variant="warning" leading={<Icon name="attention" />}>
            Counter-offer received
          </Tag>
        )}
        <StopsTimeline
          stops={quote.stops}
          titleFormatter={formatDescriptionWithZip}
          superTitleFormatter={formatFacilityName}
          subTitleFormatter={formatDate}
          compact
          tags
        />
        <Button type="button" variant="secondary" onClick={onBidClick}>
          {formatBidButtonLabel({ isUnderNegotiation })}
        </Button>
      </BodyWrapper>
    </CardWrapper>
  )
}
